import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "printGrid",
  setup(_props, _ctx) {
    return {};
  },
});
